module.exports = __webpack_public_path__ + "img/team-work.9dc3086f.jpg";